import { render, staticRenderFns } from "./threeTest.vue?vue&type=template&id=1bb28948&scoped=true"
import script from "./threeTest.vue?vue&type=script&lang=js"
export * from "./threeTest.vue?vue&type=script&lang=js"
import style0 from "./threeTest.vue?vue&type=style&index=0&id=1bb28948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb28948",
  null
  
)

export default component.exports